import { FilterLogic } from '../../utils/enums'

export const FILTER_DEFAULT_MODEL = {
  params: [],
  logic: FilterLogic.AND,
}

export const FILTER_LAST_PERIODS = ['7', '14', '30', '60', '90']
